/**
 * Points API Service
 * Handles all points-related API calls
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

/**
 * Get public points summary for a seller
 * @param {string} sellerId - Seller's user ID
 * @returns {Promise} Points summary with breakdown, stats, and badges
 */
export const getSellerPoints = async (sellerId) => {
  const { data } = await axios.get(`${API_BASE}/api/points/sellers/${sellerId}`);
  return data;
};

/**
 * Get detailed points breakdown for a seller
 * @param {string} sellerId - Seller's user ID
 * @returns {Promise} Detailed breakdown with bonus eligibility
 */
export const getSellerPointsDetailed = async (sellerId) => {
  const { data } = await axios.get(`${API_BASE}/api/points/sellers/${sellerId}/breakdown`);
  return data;
};

/**
 * Get points history for authenticated seller
 * @param {number} page - Page number (1-indexed)
 * @param {number} limit - Items per page
 * @returns {Promise} Paginated history
 */
export const getMyPointsHistory = async (page = 1, limit = 20) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(
    `${API_BASE}/api/points/me/history?page=${page}&limit=${limit}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

/**
 * Admin: Recalculate points for a seller
 * @param {string} sellerId - Seller's user ID
 * @returns {Promise} Recalculation result
 */
export const adminRecalculatePoints = async (sellerId) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.post(
    `${API_BASE}/api/admin/points/sellers/${sellerId}/recalculate`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

/**
 * Admin: Get points leaderboard
 * @param {number} limit - Number of top sellers to return
 * @returns {Promise} Leaderboard data
 */
export const getPointsLeaderboard = async (limit = 50) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(
    `${API_BASE}/api/admin/points/leaderboard?limit=${limit}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};
